import { action, computed, makeObservable, observable } from "mobx";
import type { TFinishProjectSummary } from "../types";

export class FinishProjectSummary {
  id: TFinishProjectSummary["id"];
  isProBono: boolean;

  @observable.ref
  project_already_finished: TFinishProjectSummary["project_already_finished"];

  can_be_finished_without_further_changes: TFinishProjectSummary["can_be_finished_without_further_changes"];
  can_redistribute_credit_automatically: TFinishProjectSummary["can_redistribute_credit_automatically"];

  incomplete_our_work_budget_items: TFinishProjectSummary["incomplete_our_work_budget_items"];
  incomplete_expense_budget_items: TFinishProjectSummary["incomplete_expense_budget_items"];

  underinvoiced_our_work_budget_items: TFinishProjectSummary["underinvoiced_our_work_budget_items"];
  underinvoiced_expense_budget_items: TFinishProjectSummary["underinvoiced_expense_budget_items"];
  overinvoiced_our_work_budget_items: TFinishProjectSummary["overinvoiced_our_work_budget_items"];
  overinvoiced_expense_budget_items: TFinishProjectSummary["overinvoiced_expense_budget_items"];
  overinvoiced_for_project: TFinishProjectSummary["overinvoiced_for_project"];
  underinvoiced_for_project: TFinishProjectSummary["underinvoiced_for_project"];

  constructor(src: TFinishProjectSummary, isProBono: boolean) {
    makeObservable(this);
    this.id = src.id;
    this.isProBono = isProBono;
    this.can_be_finished_without_further_changes =
      src.can_be_finished_without_further_changes;
    this.can_redistribute_credit_automatically =
      src.can_redistribute_credit_automatically;
    this.incomplete_expense_budget_items = src.incomplete_expense_budget_items;
    this.incomplete_our_work_budget_items =
      src.incomplete_our_work_budget_items;
    this.project_already_finished = src.project_already_finished;
    this.underinvoiced_our_work_budget_items =
      src.underinvoiced_our_work_budget_items;
    this.underinvoiced_expense_budget_items =
      src.underinvoiced_expense_budget_items;
    this.overinvoiced_our_work_budget_items =
      src.overinvoiced_our_work_budget_items;
    this.overinvoiced_expense_budget_items =
      src.overinvoiced_expense_budget_items;
    this.overinvoiced_for_project = src.overinvoiced_for_project;
    this.underinvoiced_for_project = src.underinvoiced_for_project;
  }

  get isOurWorkCompleted(): boolean {
    return this.incomplete_our_work_budget_items.length === 0;
  }

  get isExpenseCompleted(): boolean {
    return this.incomplete_expense_budget_items.length === 0;
  }

  get isCreditCompleted(): boolean {
    return (
      this.isProBono ||
      (!this.overinvoiced_expense_budget_items.length &&
        !this.overinvoiced_our_work_budget_items.length &&
        !this.underinvoiced_expense_budget_items.length &&
        !this.underinvoiced_our_work_budget_items.length)
    );
  }

  @computed get flagColor() {
    return this.can_be_finished_without_further_changes ? "#EEC200" : "#E33719";
  }

  @computed get pointColor() {
    return this.can_be_finished_without_further_changes ? "#47C1BF" : "#E33719";
  }

  @computed get point1Color() {
    return this.isOurWorkCompleted ? "#47C1BF" : "#E33719";
  }

  @computed get point2Color() {
    return this.isExpenseCompleted ? "#47C1BF" : "#E33719";
  }

  @computed get point3Color() {
    return this.isCreditCompleted ? "#47C1BF" : "#E33719";
  }

  @action
  finishProject() {
    this.project_already_finished = true;
  }
}
